const http = {
    headers() {
        return {
            Accept: "application/json",
            "Content-Type": "application/json",
            'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content,
        };
    }
};

window.http = http;
